import { User } from '../types';
import { AppState } from '../../rootReducer';
import { UsersState } from '../types';

export const getState = (state: AppState): UsersState => state.usersReducer;

export const getUsersList = (state: AppState): User[] => state.usersReducer.users || [];

export const isLoading = (state: AppState): boolean => state.usersReducer.isLoading;

export const getError = (state: AppState): string => state.usersReducer.error || '';

export const requestedUserIds = (state: AppState): string[] => state.usersReducer.requestedUserIds;
